import allCars from '../assets/allCars.jpg';
import priceDrops from '../assets/priceDrops.jpg';
import shipping from '../assets/shipping.jpg';
import testDrive from '../assets/testDrive.jpg';
import under20k from '../assets/under20k.jpg';

export const iconTypeMap: Record<string, string> = {
  price_tag: under20k,
  store: testDrive,
  price_drop: priceDrops,
  map: shipping,
  cars: allCars,
};

const fallBackIcon = iconTypeMap.store;

export const getIconForType = (iconType: string): string => {
  return iconTypeMap[iconType] || fallBackIcon;
};
